import { useNavigate } from "react-router-dom";
import "assets/scss/pages/ErrorPage.scss";

const ERROR_CONFIG = {
    404: {
        code: "404",
        title: "정보를 찾을 수 없습니다",
        description: "요청하신 정보가 존재하지 않거나\n삭제되었을 수 있습니다.",
    },
    500: {
        code: "500",
        title: "서버 오류가 발생했습니다",
        description: "일시적인 오류가 발생했습니다.\n잠시 후 다시 시도해 주세요.",
    },
    default: {
        code: "오류",
        title: "오류가 발생했습니다",
        description: "예상치 못한 오류가 발생했습니다.\n잠시 후 다시 시도해 주세요.",
    },
};

const ErrorPage = ({ status, onRetry }) => {
    const navigate = useNavigate();
    const config = ERROR_CONFIG[status] || ERROR_CONFIG.default;
    const is500 = status === 500;

    return (
        <div className="error-page">
            <div className="error-page__content">
                <span className="error-page__code">{config.code}</span>
                <h1 className="error-page__title">{config.title}</h1>
                <p className="error-page__desc">{config.description}</p>
                <div className="error-page__actions">
                    {is500 && onRetry && (
                        <button
                            className="btn btn-large btn-border-8 btn-purple500"
                            onClick={onRetry}
                        >
                            다시 시도
                        </button>
                    )}
                    <button
                        className={`btn btn-large btn-border-8 ${is500 && onRetry ? "btn-outline-gray300" : "btn-purple500"}`}
                        onClick={() => navigate(-1)}
                    >
                        돌아가기
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ErrorPage;
